import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Loader, TabsPanel } from 'ui';
import { EntitiesTable } from 'modules/common';
import { searchEntitiesAction } from 'store/searchResult/searchResultActions';
import { ratingTypes } from 'shared/constants/ratingTypes';
import { flattenIndustries } from 'shared/parsers';

export const RatingCoverage = () => {
  const { t } = useTranslation();
  const { businessLine } = useParams();
  const { ratingCoverageData, allIndustriesData } = useSelector(({ shared }) => ({
    ratingCoverageData: shared.ratingCoverage.data,
    allIndustriesData: shared.industries.data,
  }));
  const entities = useSelector(
    ({ searchResult }) => searchResult.entities.byRatingType[ratingTypes.CREDIT_RATING],
  );

  const allIndustries = flattenIndustries(allIndustriesData);

  const initialFilter = ratingCoverageData.find(
    item => camelCase(item.businessLine) === camelCase(businessLine),
  );
  const initialFilterModalValues =
    initialFilter &&
    allIndustries &&
    initialFilter.industries.map(({ sector }) => {
      return allIndustries.find(({ code }) => code === sector);
    });

  return initialFilter && initialFilterModalValues ? (
    <>
      <Box mb={2}>
        <Typography variant="h5">{t('Credit rating coverage')}</Typography>
      </Box>
      <TabsPanel active="entities">
        <div label={t('Entities')} value="entities" counter={entities.total}>
          <EntitiesTable
            dataSelector={entities}
            actionCreator={searchEntitiesAction}
            constantFilter={{ withRatingOnly: true }}
            initialFilter={{ industrySectors: initialFilter.industries }}
            initialFilterModalValues={{ industries: initialFilterModalValues }}
          />
        </div>
      </TabsPanel>
    </>
  ) : (
    <Loader center />
  );
};
